import React, { useState, useEffect } from 'react';
import { HiChevronLeft, HiChevronRight, HiOutlineExternalLink } from 'react-icons/hi';
import { motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import { urlFor, client } from '../../client';
import './Articles.scss';

const Articles = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [articles, setArticles] = useState([]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? articles.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === articles.length - 1 ? 0 : prev + 1));
  };

  useEffect(() => {
    const query = '*[_type == "articles"]';
    client.fetch(query).then((data) => {
      setArticles(data);
    });
  }, []);

  if (!articles.length) return null;

  const currentArticle = articles[currentIndex];

  return (
    <div className="articles">
      {/* Header */}
      <motion.div
        className="articles__header"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <h2 className="articles__title">
          My <span className="gradient-text">Articles</span>
        </h2>
        <p className="articles__subtitle">
          Thoughts and tutorials on development
        </p>
      </motion.div>

      {/* Article Display */}
      <motion.div
        className="articles__container"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        viewport={{ once: true }}
      >
        <article className="articles__card">
          {/* Image */}
          <div className="articles__card-image">
            <img src={urlFor(currentArticle.imgurl)} alt={currentArticle.name} />
          </div>

          {/* Content */}
          <div className="articles__card-content">
            <div className="articles__card-meta">
              <span className="articles__card-platform">{currentArticle.company}</span>
              <span className="articles__card-dot">•</span>
              <span className="articles__card-count">{currentIndex + 1} of {articles.length}</span>
            </div>

            <h3 className="articles__card-title">{currentArticle.name}</h3>
            
            <p className="articles__card-summary">{currentArticle.summary}</p>

            <a
              href={currentArticle.articleLink}
              target="_blank"
              rel="noopener noreferrer"
              className="articles__card-link"
            >
              Read Article
              <HiOutlineExternalLink />
            </a>
          </div>
        </article>

        {/* Navigation */}
        <div className="articles__nav">
          <button 
            className="articles__nav-btn" 
            onClick={handlePrev}
            aria-label="Previous article"
          >
            <HiChevronLeft />
          </button>
          
          {/* Dots */}
          <div className="articles__dots">
            {articles.map((_, index) => (
              <button
                key={index}
                className={`articles__dot ${index === currentIndex ? 'active' : ''}`}
                onClick={() => setCurrentIndex(index)}
                aria-label={`Go to article ${index + 1}`}
              />
            ))}
          </div>

          <button 
            className="articles__nav-btn" 
            onClick={handleNext}
            aria-label="Next article"
          >
            <HiChevronRight />
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default AppWrap(
  MotionWrap(Articles, 'app__article'),
  'articles',
  'app__whitebg',
);
